import styled from 'styled-components';
import colors from '../../../utils/colors';
import {
  formatPhoneNumber,
  generatePreWhatsUpMessageLink,
  getBackgroudColorByStatus,
  getColorByStatus,
  getLabelByStatus,
} from '../../../utils/helperFunctions';
import dateFormat from 'dateformat';
import RowDropdown from './RowDropdown';
import { useEffect, useState } from 'react';
import { useUpdateLeadsStatusMutation } from '../../../app/services/workspace.service';
import { useNavigate } from 'react-router-dom';

const dropdownOptions: { [key: string]: string } = {
  default: 'Durum seçiniz',
  busy: 'Meşgul',
  offered: 'Teklif yapıldı',
  rejected: 'Olumsuz',
  notReached: 'Ulaşılamadı',
  sold: 'Satış yapıldı',
  wrongNumber: 'Yanlış numara',
};

const Row = ({
  row,
  index,
  moreThanOnePacket,
  onFetchData,
  currentPage,
}: any) => {
  const [isOpened, setOpen] = useState(false);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [condition, setSelectedCondition] = useState(row.condition);
  const [currentStatus, setCurrentStatus] = useState(row.status);
  const [updateLeadsStatus] = useUpdateLeadsStatusMutation();
  const navigate = useNavigate();

  const onTriggerAction = async (
    currentStatus: string,
    leadId: string,
    condition: string
  ) => {
    try {
      const { data }: any = await updateLeadsStatus({
        nextStatus: currentStatus === 'waiting' ? 'called' : null,
        leadId,
        currentStatus,
        condition,
      });

      if (data?.success) {
        setCurrentStatus(data?.data?.currentStatus);
        setSelectedCondition(data?.data?.condition);
      }
    } catch (error) {
      console.log(error);
    } finally {
      onFetchData();
    }
  };

  useEffect(() => {
    setOpen(false);
    setSelectedCondition(row.condition);
    setCurrentStatus(row.status);
  }, [row]);

  const handleRowClick = () => {
    setOpen((prev) => !prev);
  };

  const dropdownItemClickHandle = async (key: any) => {
    setSelectedCondition(key);
    await onTriggerAction(currentStatus, row.leadId, key);
  };

  return (
    <>
      <StyledRow
        index={index}
        moreThanOnePacket={moreThanOnePacket}
        onClick={handleRowClick}
      >
        <StyledTdForName $isOverFlowHidden $radiusLeft>
          {row.fullname}
        </StyledTdForName>
        <StyledTdForDate>
          {dateFormat(row.createdAt, 'dd-mm-yyyy HH:MM')}
        </StyledTdForDate>
        <StyledTdForNumber $isWrap>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              justifyContent: 'space-between',
              width: '145px',
            }}
          >
            {row.condition === 'waiting'
              ? row?.normalizedPhone
              : formatPhoneNumber(row.phone)}
            {moreThanOnePacket && (
              <ImgContainer>
                <img
                  onMouseEnter={() => setTooltipVisible(true)}
                  onMouseLeave={() => setTooltipVisible(false)}
                  style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                  src='/assets/icons/blue-down-arrow.png'
                />
                {isTooltipVisible && (
                  <Tooltip $isDropdownOpen={isOpened}>
                    Bu numara ile birden fazla başvuru yapılmıştır. (Görmek için
                    tıklayınız.)
                  </Tooltip>
                )}
              </ImgContainer>
            )}
          </div>
        </StyledTdForNumber>
        <StyledTdForLocation $isOverFlowHidden>
          {row.leadDistrict}
        </StyledTdForLocation>
        <StyledTdForCompany $isOverFlowHidden>
          {row?.companyData?.isim}
        </StyledTdForCompany>
        <StyledTdForCallStatus $status={currentStatus}>
          <StyledStatus $status={currentStatus}>
            {getLabelByStatus(currentStatus)}
          </StyledStatus>
        </StyledTdForCallStatus>
        <StyledTdForStatus $radiusRight>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '300px',
            }}
          >
            <DropdownContainer>
              <StyledSelect
                disabled={currentStatus === 'waiting' ? true : false}
                currentStatus={currentStatus}
                value={dropdownOptions[condition]}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  const selectedConditionValue = e.target.value;
                  const selectedConditionKey = Object.keys(
                    dropdownOptions
                  ).find(
                    (key) => dropdownOptions[key] === selectedConditionValue
                  );
                  dropdownItemClickHandle(selectedConditionKey);
                }}
              >
                {Object.entries(dropdownOptions).map(([key, value], index) => (
                  <StyledOption disabled={key === 'default'}>
                    {value}
                  </StyledOption>
                ))}
              </StyledSelect>
            </DropdownContainer>
            <div
              style={{
                display: 'flex',
                gap: '5px',
              }}
            >
              <img
                style={{ cursor: 'pointer' }}
                width={36}
                src='/assets/icons/info-icon.png'
                onClick={(e) => {
                  e.stopPropagation();
                  // onShowDetailToggle();
                  // onSelectDetailHandler(showDetail ? '' : row.leadId);
                  navigate(row.leadId, { state: { row, currentPage } });
                }}
              />
              {currentStatus === 'waiting' && (
                <img
                  style={{ cursor: 'pointer' }}
                  width={36}
                  onClick={(e) => {
                    e.stopPropagation();
                    onTriggerAction(currentStatus, row.leadId, condition);
                  }}
                  src='/assets/icons/call-icon.png'
                />
              )}
              {currentStatus !== 'waiting' && (
                <a
                  href={generatePreWhatsUpMessageLink(row.phone)}
                  target='_blank'
                  style={{ height: '36px' }}
                >
                  <img
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    src='/assets/icons/whatsapp.png'
                  />
                </a>
              )}
            </div>
          </div>
        </StyledTdForStatus>
      </StyledRow>
      {moreThanOnePacket && isOpened && <RowDropdown row={row} />}
    </>
  );
};

const StyledRow = styled.tr<{ index: number; moreThanOnePacket: boolean }>`
  background: ${({ index }) =>
    index % 2 === 0 ? colors.mainLightBlue : 'white'};
  cursor: ${({ moreThanOnePacket }) =>
    moreThanOnePacket ? 'pointer' : 'unset'};
  height: 80px;
`;

const StyledSelect = styled.select<{ currentStatus: string }>`
  cursor: ${({ currentStatus }) =>
    currentStatus === 'waiting' ? 'no-drop' : 'pointer'};
  border: 1px solid ${colors.mainBlue};
  border-radius: 10px;
  text-align: center;
  margin-right: 20px;
  font-weight: 400;
  font-size: 16px;
  color: ${colors.mainBlue};
  width: 200px;
  height: 30px;
  background-color: ${({ currentStatus }: any) =>
    currentStatus === 'waiting' ? '#e9e9e9' : 'white'};
`;

const StyledOption = styled.option`
  font-size: 16px;
`;

const DropdownContainer = styled.div`
  position: relative;
`;

const commonCellStyle = ({
  $isOverFlowHidden,
  $isWrap,
  $radiusLeft,
  $radiusRight,
}: {
  $isOverFlowHidden?: boolean;
  $isWrap?: boolean;
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}) => `
  line-height: 24px;
  padding: 0px 10px 0px 10px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: ${$isOverFlowHidden ? 'hidden' : 'none'};
  white-space: ${$isWrap ? 'wrap' : 'nowrap'};
  border-top-left-radius: ${$radiusLeft ? '14px' : '0px'};
  border-bottom-left-radius: ${$radiusLeft ? '14px' : '0px'};
  border-top-right-radius: ${$radiusRight ? '14px' : '0px'};
  border-bottom-right-radius: ${$radiusRight ? '14px' : '0px'};
  @media (max-width: 768px) {
    line-height: 16px;
  }
`;

const StyledTd = styled.td<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
  $status?: string;
  $isWrap?: boolean;
  $isOverFlowHidden?: boolean;
}>`
  ${commonCellStyle}
`;

const StyledTdForName = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  min-width: 140px;
  max-width: 140px;
  font-weight: 700;
  font-size: 16px;
`;

const StyledTdForDate = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  width: 200px;
`;

const StyledTdForNumber = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  width: 180px;
`;

const StyledTdForCompany = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  max-width: 100px;
  min-width: 100px;
`;

const StyledTdForLocation = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  max-width: 100px;
  min-width: 100px;
`;

const StyledTdForCallStatus = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  width: 150px;
  min-width: 150px;
`;

const StyledTdForStatus = styled(StyledTd)<{
  $radiusLeft?: boolean;
  $radiusRight?: boolean;
}>`
  width: 350px;
`;

const StyledStatus = styled.div<{ $status: string }>`
  color: ${({ $status }) => getColorByStatus($status)};
  background-color: ${({ $status }) => getBackgroudColorByStatus($status)};
  border: 1px solid ${({ $status }) => getBackgroudColorByStatus($status)};
  border-radius: 12px;
  padding: 2px 5px;
  min-width: fit-content;
  text-align: center;
`;

const ImgContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Tooltip = styled.div<{
  $isDropdownOpen?: boolean;
}>`
  position: absolute;
  bottom: -29.5px;
  right: -150px;
  transform: translateX(50%);
  width: 280px;
  background-color: #455bd5;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 15px 15px;
  display: ${({ $isDropdownOpen }) => ($isDropdownOpen ? 'none' : '')};
  &:after {
    content: ' ';
    position: absolute;
    top: 50%;
    left: -8.5px;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent #455bd5 transparent transparent;
  }
`;

export default Row;
